<template>
  <div class="imdiv" v-on:click="goArtistPortfolio">
    <div class="square-filler">
      <ix-router-link :to="'/artists/' + artist.portfolio_url">
        <transition name="fade"><img v-if="seen"
          :src="getImageUrl()" :alt="artist.formatted_name" class="main" /></transition>
      </ix-router-link>
    </div>
    <div v-if="!$store.state.stopPreviews">
      <template v-if="isGif && inView">
        <square-gif-viewer :src="mediaPath" />
      </template>
      <template v-if="hasPreviewClip && inView">
        <square-clip-viewer :src="previewClipUrl" />
      </template>
    </div>
    <div class="greybar" v-show="loaded">
      <div>
        <div class="a-name">
          <ix-router-link :to="portfolioUrl">{{ artist.formatted_name }}</ix-router-link>
        </div>
        <div>
          <small-button v-on:click="zoom">{{ $nippets.play }}</small-button>
        </div>
      </div>
      <div class="likebox-holder low"><like-box :imageId="image.image_id" /></div>
    </div>
  </div>
  
</template>

<script>
import SquareGifViewer from '@/components/widgets/SquareGifViewer.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import SquareClipViewer from '@/components/widgets/SquareClipViewer.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'
export default {
  components: {
    SquareGifViewer,
    LikeBox,
    SquareClipViewer
  },
  mixins: [ViewablePanel],
  props: {
    artistData: Object,
    pageSettings: String
  },
  computed: {
    isGif () {
      if(!this.image.swf) return false
      return this.image.swf.toLowerCase().endsWith('.gif')
    },
    mediaPath () {
      return this.$k.imagebase + 'media/artist/' + this.artist.portfolio_url + '/' + this.image.swf
    },
    previewClipUrl () {
      if(this.image.swf) {
        return this.$k.getPreviewClipUrl(this.image, this.artist)
      }
      return ''
    }
  },
  data: function () {
    return {
      artist: { galleries: [] },
      image: {},
      loaded: false,
      hasPreviewClip: false,
      portfolioUrl: ''
    }
  },
  created () {
    if(this.artistData.artist_id){
      this.loadArtist()
    }
  },
  methods: {
    goArtistPortfolio: function () {
      this.$emit('click', this.artist)
    },
    getImageUrl: function() {
      return this.$k.getImageCrop500(this.artistData.images[0].url)
    },
    loadArtist: async function () {
      this.loaded = false
      this.hasPreviewClip = false
      
      if(this.artistData) {
        this.artist = await this.$store.dispatch('fetchArtistById', this.artistData.artist_id)
        this.image = this.artistData.images[0]
        this.loaded = true
        if(this.$k.canHaveClip(this.image.swf)) {
          this.hasPreviewClip = true
        }
        if(this.artist.animation) {
          this.portfolioUrl = '/animators/' + this.artist.portfolio_url
        }
        else {
          this.portfolioUrl = '/artists/' + this.artist.portfolio_url
        }
      }
    },
    zoom: async function () {
      this.$emit('zoom', { image: this.image, artist: this.artist} )
    }
    
  },
  watch: {
    artistData: function () {
      if(this.artistData.artist_id) {
        this.loadArtist()
      }
    }
  }
}
</script>

<style scoped>
.greybar{
  position:absolute;
  transition:all 0.3s ease;
  bottom:0;
  left:0;
  width:100%;
  box-sizing:border-box;
  transform: translateY(100%);
}

.imdiv:hover .greybar{
  transform:none;
}

.imdiv{
  overflow:hidden;
}

.likebox-holder.low{
  top:auto;
  bottom:10px;
}

.a-name {
  margin-bottom:6px;
}

img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}

.square-filler{
  position:relative;
  overflow:hidden;
  width:100%;
  padding-bottom:100%;
  height:1;
}

.imdiv:hover img.main{
  width:107%!important;
}
</style>